export function setMarkerIcon(
  marker,
  url: string,
  scaledSize: {
    width: number;
    height: number;
  },
) {
  const img = document.createElement('img');
  img.src = url;
  img.height = scaledSize.height;
  img.width = scaledSize.width;
  marker.content = img;
}
